<div class="d-flex align-items-center justify-content-between m-b-16 p-x-20 p-t-16">
    <h3>{{ 'LABEL.ADD_LABEL' | translate }} {{ 'ENTITY.PRESCRIPTION_TEMPLATE' | translate }}</h3>
    <button mat-icon-button mat-dialog-close class="d-flex justify-content-center">
        <i-tabler name="x" class="icon-20 d-flex"></i-tabler>
    </button>
</div>
<mat-dialog-content>
    <form [formGroup]="templateForm">
        <div class="row m-t-8">
            <div class="col-lg-12">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'ENTITY.PRESCRIPTION_TEMPLATE' | translate }}</mat-label>
                    <input matInput placeholder="{{ 'ENTITY.PRESCRIPTION_TEMPLATE' | translate }}"
                        formControlName="name">
                    <mat-error *ngIf="templateForm.get('name')?.hasError('required')">
                        {{ 'REQUIRED.NAME' | translate }}
                    </mat-error>
                    <mat-error *ngIf="templateForm.get('name')?.hasError('maxlength')">
                        {{ 'REQUIRED.MAXIMUM100' | translate }}
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row m-t-8">
            <div class="col-lg-12">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'LABEL.DESCRIPTION_LABEL' | translate }}</mat-label>
                    <textarea matInput placeholder="{{ 'LABEL.DESCRIPTION_LABEL' | translate }}" cols="5" rows="3"
                        formControlName="description"></textarea>
                    <mat-error *ngIf="templateForm.get('description')?.hasError('maxlength')">
                        {{ 'REQUIRED.MAXIMUM255' | translate }}
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
    </form>
</mat-dialog-content>
<mat-dialog-actions class="d-flex justify-content-end">
    <div class="row m-t-4 p-r-16">
        <div class="col-lg-8"></div>
        <div class="col-lg-4 d-flex justify-content-end">
            <button mat-stroked-button class="m-r-5" (click)="onCloseDialog()">
                {{ 'BUTTON.BTN_CLOSE' | translate}}</button>
            <button mat-flat-button color="primary" (click)="onSaveTemplate()">
                {{ 'BUTTON.BTN_SAVE' | translate }}</button>
        </div>
    </div>
</mat-dialog-actions>
